// extracted by mini-css-extract-plugin
var _1 = "styles-module__staticMapImage___KLUoX";
var _2 = "styles-module__statsContainer___pHGmd";
var _3 = "styles-module__statsSection___xqtxL";
export { _1 as "staticMapImage", _2 as "statsContainer", _3 as "statsSection" }
